import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { TicketOfferView, TicketOfferViewProxy } from '../views/ticketoffer';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { TicketType } from '../types';
import { OfferType } from '../types';
import { TicketProductType } from '../types';

import { Ticket } from './ticket';

const _schema = {
    "name": "TICKETOFFER",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "amount", type: "number" },        
        { name: "ticket", type: "objid" },
        { name: "offer", type: "objid" },
        { name: "price", type: "number" },
        { name: "charge", type: "number" },
        { name: "fixed", type: "boolean" },
        { name: "refund", type: "number" }
    ],
    relate: [
        { direction: ">", target: "TICKET", by: "ticket", name: "ticket", reason: "ticket", child: false, class: TicketType },
        { direction: ">", target: "OFFER", by: "offer", name: "offer", reason: "offer", child: false, class: OfferType },
        { direction: "<", target: "TICKETPRODUCT", by: "offer", name: "product", reason: "products", child: true, class: TicketProductType }
    ]
} as const;

const _TicketOfferClass = CreateObject(_schema);
if (!_TicketOfferClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class TicketOffer extends _TicketOfferClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): TicketOffer {
        return this._Copy(store) as TicketOffer;
    }

    override get viewProxy(): TicketOfferView {
        return TicketOfferViewProxy(this, this.data);
    }

    /** Changelog rows lack `TICKET.offers`; register on link (see TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || relation !== 'ticket' || !(related instanceof Ticket)){
            return;
        }

        if (related === this.ticket){
            related.AddOffer(this);
        }
        else {
            related.DelOffer(this);
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/
    
    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.ticket){
            if ((this.status == 'DE') && !this.Commited){
                this.ticket.DelOffer(this);
            }
            else {
                this.ticket.DoRefresh(this.table);
            }    
        }
    }    
    
    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}
